import { defineComponent as e } from "vue";
import o from "./td-longtail-vue-components3.js";
const a = /* @__PURE__ */ e({
  __name: "forward-backward-button",
  props: {
    direction: { default: "left" },
    primary: { type: Boolean },
    outline: { type: Boolean },
    secondary: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["clicked"],
  setup(t) {
    return { __sfc: !0, LinkButton: o };
  }
});
export {
  a as default
};
